import { render } from "./RollBets.vue?vue&type=template&id=4b2500e2&scoped=true"
import script from "./RollBets.vue?vue&type=script&lang=js"
export * from "./RollBets.vue?vue&type=script&lang=js"

import "./RollBets.vue?vue&type=style&index=0&id=4b2500e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2500e2"]])

export default __exports__